import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import BackToTop from '../common/BackToTop';
import { useSEO } from '../../hooks/useSEO';

const Layout = () => {
  const location = useLocation();
  
  // 根据路径设置默认 SEO
  const getPageKey = (pathname) => {
    if (pathname === '/') return 'home';
    if (pathname.startsWith('/universities')) return 'universities';
    if (pathname.startsWith('/programs')) return 'programs';
    if (pathname.startsWith('/services')) return 'services';
    if (pathname.startsWith('/about')) return 'about';
    if (pathname.startsWith('/contact')) return 'contact';
    if (pathname.startsWith('/application-query')) return 'applicationQuery';
    return 'home';
  };
  
  useSEO(getPageKey(location.pathname));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <BackToTop />
    </Box>
  );
};

export default Layout; 